import React, { useEffect, useState, useRef } from "react";
import { Flex, Stack, Heading, Text, Box, Button } from "@chakra-ui/react";
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useParams } from "react-router-dom";
import CustomFormInput from "../components/FormInputFields";
import axios from "axios";
import CommonVars from "../components/CommonVars";

function ResetPasswordScreen() {
    const userid = parseInt(useParams().id);
    const token = String(useParams().token);
    const notValidRef = useRef();
    const successRef = useRef();
    const [notValidMsg, setNotValidMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');

    // retrieve token from database to see if exist or still valid
    const getResetToken = async () => {
        axios.get(`${CommonVars.API_URL}/reset-password/${token}`)
        .catch((error) => {
            console.log(error);
            if (error.response.status === 401) {
                setNotValidMsg('Reset password link has expired.');
            } else if (error.response.status === 404) {
                setNotValidMsg('Reset password link cannot be used anymore.');
            } else {
                setNotValidMsg('Something went wrong.');
            }
        })
    } 

    useEffect(() => {
        setTimeout(() => {
            getResetToken();
        }, 1000)
    });

    return (
        <Formik
            initialValues={{
                password: '',
                cfmPassword: '',
            }}
            validationSchema={Yup.object({
                password: Yup.string()
                .min(8, 'Password is too short - should be 8 characters minimum.')
                .matches(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/, 'Minimum eight characters, with at least one letter and one number')
                .required('Password is required'),
                cfmPassword: Yup.string()
                .oneOf([Yup.ref('password'), null], 'Password and Confirm Password does not match')
                .required('Confirm Password is required'),
            })}
            onSubmit = {(values, { setSubmitting, resetForm }) => {
                // prepare the request body
                const resetPwdRequestBody = {
                    newpassword: values.password,
                }
                // access backend to update with new password
                axios.put(`${CommonVars.API_URL}/reset-password/${userid}/${token}`, resetPwdRequestBody)
                .then((res) => {
                    console.log(res.data);
                    if (res.data === '0 row(s) affected') {
                        setNotValidMsg('Reset password link cannot be used anymore.');
                        resetForm();
                        setSubmitting(false);
                    } else {
                        // delete all reset password token linked with the user
                        return axios.delete(`${CommonVars.API_URL}/delete-reset-token/${userid}/`)
                        .then(() => {
                            setSuccessMsg('Password has been reset successfully!');
                            setTimeout(() => {
                                setSuccessMsg();
                            }, 6000)
                            resetForm();
                            setSubmitting(false);
                        })
                    }
                })
                .catch((error) => {
                    console.log(error.response);
                    setNotValidMsg('Password reset failed.');
                    resetForm();
                    setSubmitting(false);
                })
            }}
        >
            {props => (
                <Flex 
                    minH={'100vh'}
                    align={'center'}
                    justify={'center'}
                    bg={'#F4F4F4'}
                >
                    <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
                        <Stack align={'center'}>
                            <Heading fontSize={'4xl'}>Reset your password</Heading>
                            <Text>You can proceed back to login after resetting your password.</Text>
                        </Stack>
                        <Box
                            rounded={'lg'}
                            bg={'white'}
                            boxShadow={'lg'}
                            p={8}
                        >
                            <Form>
                                <p ref={successRef} className={successMsg ? "successmsg" : "offscreen"}>{successMsg}</p>
                                <p ref={notValidRef} className={notValidMsg ? "notvalidmsg" : "offscreen"}>{notValidMsg}</p>
                                <Stack spacing={4}>
                                    {/* New password */}
                                    <CustomFormInput
                                        label="New Password" 
                                        name="password" 
                                        type="password"
                                        placeholder="Enter Password"
                                    />
                                    {/* Confirm new password */}
                                    <CustomFormInput
                                        label="Confirm New Password" 
                                        name="cfmPassword" 
                                        type="password"
                                        placeholder="Confirm Password"
                                    />
                                    <Button
                                        type="submit"
                                        bg={'black'}
                                        color={'white'}
                                        _hover={{
                                        bg: '#37404A',
                                        }}
                                    >
                                        {props.isSubmitting ? 'Resetting Password...' : 'Reset Password'}
                                    </Button>
                                </Stack>
                            </Form>
                        </Box>
                    </Stack>
                </Flex>
            )}
        </Formik>
    )
}

export default ResetPasswordScreen;